<script setup lang="ts">
import type { PageArchiveEntryFragment } from '#graphql-operations'

interface ArchiveHeroProps {
  data: PageArchiveEntryFragment
}

const props = defineProps<ArchiveHeroProps>()
const colorScheme = useColorScheme(props.data.colorScheme)
</script>

<template>
  <Section class="archiveHero" :class="colorScheme">
    <HeroMedia
      v-if="data.coverMedia.length"
      :media="data.coverMedia"
      :img-props="{ sizes: '1024px lg:100vw', alt: data.headingText }"
      caption-class="c-$color-scheme-foreground bg-$color-scheme-background"
    >
      <div class="grid grid-cols-4 h-full">
        <div class="text-center col-span-full h-full lg:text-left">
          <Text v-if="data.introLabel" :html="data.introLabel" class="typo-sans-1 uppercase capsize" />
          <div class="flex flex-col h-full space-y-5 lg:pt-4">
            <Text :html="data.heading" class="typo-serif-4" />
            <div v-if="data.description || data.links?.length" class="flex flex-1 flex-col gap-8">
              <Text v-if="data.description" :html="data.description" class="typo-serif-1 w-full space-y-1lh 2xl:max-w-lg" />
              <div v-if="data.links?.length" class="mt-auto flex gap-2 items-center justify-center lg:justify-start">
                <ButtonLink v-for="link in data.links" :key="link!.id" :link="link?.customLink" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeroMedia>
    <div v-else class="mt-2.5 lg:mt-7">
      <div class="container c-$color-scheme-foreground flex flex-col gap-16">
        <div class="text-center flex flex-col space-y-6.5 lg:space-y-10">
          <h1 v-if="data.introLabel" class="typo-sans-1 uppercase capsize">
            <Text :html="data.introLabel" />
          </h1>

          <h2 v-if="data.heading" class="typo-serif-4">
            <Text :html="data.heading" />
          </h2>
        </div>
        <div v-if="data.description || data.links?.length" class="mx-auto flex flex-col gap-8">
          <Text v-if="data.description" :html="data.description" class="typo-serif-1 text-center" />
          <div v-if="data.links?.length" class="flex gap-2 items-center justify-center">
            <ButtonLink v-for="link in data.links" :key="link!.id" :link="link?.customLink" />
          </div>
        </div>
      </div>
    </div>
  </Section>
</template>
